import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";

export default function DropdownPropertys({ categoriesType, bannerFilter, filterCallBack, handlesearch }) {
    const [categoryfilter, setCategoryfilter] = useState("Residential");
    const [selectOptions, setSelectOptions] = useState(bannerFilter);
    const [categoryType, setCategoryType] = useState([]);
    const [categories, setCategories] = useState([]);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]);

    useEffect(() => {
        if (bannerFilter) setSelectOptions(bannerFilter);
    }, [bannerFilter]);

    useEffect(() => {
        if (categoriesType.length > 0) {
            const topLevelCategories = categoriesType.filter((item) => item.baseId === null);
            const subCategories = categoriesType.filter((item) => item.baseId !== null);
            setCategoryType(topLevelCategories);
            setCategories(subCategories);
            let topCategoryName = "";
            if (bannerFilter.categories.length > 0) {
                const filteredSub = subCategories.filter((subCategory) => bannerFilter.categories?.includes(subCategory.slug.toLowerCase() || subCategory.name));
                if (filteredSub.length > 0) {
                    const firstSubCategory = filteredSub[0];
                    const topCategory = topLevelCategories.find((category) => category.uId === firstSubCategory.baseId);
                    topCategoryName = topCategory ? topCategory.name : ""; // Set to the top-level category name or empty string
                }
            }
            let cName = topCategoryName ? topCategoryName : bannerFilter.categorySlug || "Residential";
            setCategoryfilter(cName);
            const selectedTop = categoriesType.find((item) => item.name === cName);
            if (selectedTop) {
                const relatedSub = subCategories.filter((sub) => sub.baseId === selectedTop.uId);
                setFilteredSubCategories(relatedSub);
            } else setFilteredSubCategories([]);
        }
    }, [categoriesType]);

    const handleCategoryfilter = (e, value) => {
        e.preventDefault();
        e.stopPropagation();
        setCategoryfilter(value);
        let option = { ...selectOptions };
        if (value !== "") option["categorySlug"] = value;
        else option["categorySlug"] = "";
        option["categories"] = [];
        setSelectOptions(option);
        filterCallBack(option);
        const selectedTop = categoryType.find((item) => item.name === value);
        if (selectedTop) {
            const relatedSub = categories.filter((sub) => sub.baseId === selectedTop.uId);
            setFilteredSubCategories(relatedSub);
        } else setFilteredSubCategories([]);
    };

    const handleSubCaegory = (e, value, type) => {
        e.preventDefault();
        e.stopPropagation();
        const option = { ...selectOptions };
        if (type !== "") option["categorySlug"] = categoryfilter;
        else option["categorySlug"] = "";
        const currentCategories = Array.isArray(option["categories"]) ? [...option["categories"]] : [];
        if (currentCategories.includes(type)) {
            option["categories"] = currentCategories.filter((item) => item !== type);
        } else {
            option["categories"] = [...currentCategories, type];
        }
        setSelectOptions(option);
        filterCallBack(option);
    };

    const handleRemove = () => {
        let option = selectOptions;
        option["categorySlug"] = "Residential";
        option["categories"] = [];
        setSelectOptions(option);
        filterCallBack(option);
        if(handlesearch) handlesearch(1, option);
        // setCategoryfilter("Residential");
    };

    return (
        <div className="filter-dropdown">
            <DropdownButton
                className="custom-dropdown"
                title={
                    selectOptions?.categories.length > 0
                        ? selectOptions?.categories.length === 1
                            ? filteredSubCategories?.find((item) => item.slug === selectOptions?.categories[0])?.name
                            : `${categoryfilter} (${selectOptions.categories.length})`
                        : categoryfilter ?? "Residential"
                }
            >
                <ul className="tab_dropdown">
                    {categoryType.map((item, i) => (
                        <li className={(categoryfilter ? categoryfilter : "Residential") === item.name ? "filter_active" : ""} onClick={(e) => handleCategoryfilter(e, item.name)} key={i}>
                            {item.name}
                        </li>
                    ))}
                </ul>
                <div className={`dropdown-grid dropdown_hover ${filteredSubCategories?.length > 0 ? "dropdown_scroll" : ""}`}>
                    {filteredSubCategories.map((item, i) => (
                        <Dropdown.Item
                            className={Array.isArray(selectOptions?.categories) && selectOptions?.categories?.includes(item.slug) ? "active" : ""}
                            as="span"
                            key={i}
                            onClick={(e) => handleSubCaegory(e, item.name, item.slug)}
                        >
                            {item.name}
                        </Dropdown.Item>
                    ))}
                </div>
                {selectOptions?.categories?.length > 0 && (
                    <Dropdown.Item as="span" className="full-width">
                        <button className="reset-button" onClick={handleRemove}>
                            Reset
                        </button>
                        <button className="done-button">Done</button>
                    </Dropdown.Item>
                )}
            </DropdownButton>
        </div>
    );
}
